import { createApp } from 'vue'
import { LoadGeneral, useAuthStore } from '@core/global'
import router from '@/router'
import App from '@/App.vue'

const app = createApp(App)

app.use(LoadGeneral)
app.use(router)

useAuthStore().requestMemberInfo()

app.mount('#app')

